import TableBasic, { TableRow } from "../../../Table/TableBasic";
import GroupIcon from "../../../icons/GroupIcon";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../../../api/util";
import Spinner from "../../../spinner/Spinner";
import { DEFAULT_ERROR } from "../../../../constants/errors";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import { SortBy } from "../../../../interfaces/table";
import { TD, getHeaderActiveColumns } from "../../../../util/table";
import { defaultBrugerColumns } from "../../../../config/admin/columnsConfig";
import { BrugereDTO, IBrugereFields } from "../../../../interfaces/admin";
import { useContext } from "react";
import { UserQueryContext } from "../../../../context/UserContext";
import useLocalStorageState from "use-local-storage-state";
import IngenRegistreringer from "../../person/id/IngenRegistreringer";
import { adminBrugerFormConfig } from "../../../../config/form/admin/adminBrugerFormConfig";
import { orderBy } from "../../../../util/orderBy";

export default function Brugere() {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "AdminWrite");
  const { data, isLoading, error, refetch } = useQuery<BrugereDTO[]>({
    queryKey: ["brugere"],
    queryFn: async function () {
      return get({
        query: "brugere",
      });
    },
  });
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "adminBrugereSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const [activeColumns, setActiveColumns] = useActiveColumns<IBrugereFields>(
    "admin-brugere-active-columns",
    defaultBrugerColumns,
  );

  if (error) return <div style={{ color: "red" }}>{DEFAULT_ERROR.message}</div>;
  if (isLoading) return <Spinner />;
  if (!data?.length) {
    return (
      <IngenRegistreringer
        invalidateData={refetch}
        editConfig={canWrite ? adminBrugerFormConfig() : undefined}
      />
    );
  }

  return (
    <div className="container">
      <h3 className="d-flex gap-2 align-items-center">
        <span className="c-theme-icon c-theme-icon--defaultSize text-primary bg-primary-light">
          <GroupIcon width={21} />
        </span>
        <span>Brugere</span>
      </h3>
      <div className="c-accordion">
        <TableBasic
          columns={activeColumns}
          defaultColumns={defaultBrugerColumns}
          setActiveColumns={setActiveColumns}
          editConfig={adminBrugerFormConfig()}
          invalidateData={refetch}
          headerRow={
            <>
              {getHeaderActiveColumns(activeColumns, {
                defaultSortBy,
                setSortBy,
                sortBy,
              })}
            </>
          }
        >
          {orderBy(
            data,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((rowData, i) => {
            return (
              <TableRow
                key={i}
                invalidateData={refetch}
                editConfig={
                  canWrite ? adminBrugerFormConfig(rowData.id) : undefined
                }
              >
                <>
                  {activeColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return <TD key={col.field} col={col} rowData={rowData} />;
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBasic>
      </div>
    </div>
  );
}

const defaultSortBy: SortBy<IBrugereFields>[] = [
  {
    direction: "asc",
    field: "navn",
  },
];
